type GetGuidanceUrlParams = {
  guidanceToolName: string
  isAdmin?: boolean
  permalink: string
  redirectPage: string
}

export const getGuidanceUrl = ({
  guidanceToolName,
  isAdmin,
  permalink,
  redirectPage,
}: GetGuidanceUrlParams): string => {
  const baseUrl =
    process.env.NEXT_PUBLIC_ENV === "production" ? "https://uj-auth.jobteaser.com" : "https://uj-auth.jobteaser.dev"

  const userParam = isAdmin ? "jobteaser" : "public"
  const organizationDomainValue = permalink !== "www" ? permalink : userParam
  const params = `redirect=${redirectPage}&organization_domain=${organizationDomainValue}`

  const path = `/api/auth/${guidanceToolName}/jt-connect`

  return `${baseUrl}${path}?${params}`
}
